const SearchBar = ({ handleSearch }: { handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void }) =>
(
    <div className="col-12 mb-1">
        <div>
            <input
                type="text"
                className="form-control"
                placeholder="Search for an endpoint..."
                onChange={(e) => handleSearch(e)}
            />
        </div>
    </div>
);

export default SearchBar;